import i18n, { t } from 'i18next';

// Resolve a BCP 47 / ISO 639-1 language code to its display name in the UI language using
// the browser's Intl.DisplayNames. Falls back to the raw code if the runtime rejects it
// (e.g. "en-us" -> "angielski"; unknown codes pass through).
// One formatter per UI language, built on first use: a module-level one would be pinned to
// whatever language was active at import.
const displayNamesByLanguage = new Map<string, Intl.DisplayNames>();

const displayNames = () => {
  const language = i18n.language;
  let formatter = displayNamesByLanguage.get(language);
  if (!formatter) {
    formatter = new Intl.DisplayNames([language], { type: 'language' });
    displayNamesByLanguage.set(language, formatter);
  }
  return formatter;
};

export const languageName = (code?: string | null): string => {
  if (!code) return t('states.detecting');
  try {
    return displayNames().of(code) ?? code;
  } catch {
    return code;
  }
};
